<template>
  <Panel header="Danh sách tài khoản">
    <div class="w-full">
      <DataTable
        :loading="isLoading"
        :value="list"
        :paginator="true"
        stripedRows
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        :rowHover="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        v-model:filters="filters"
        :globalFilterFields="['fullname', 'username']"
        currentPageReportTemplate="Có tổng số {totalRecords} tài khoản"
      >
        <template #header>
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex items-center gap-3">
              <Button
                type="button"
                icon="pi pi-filter-slash"
                label="Xoá lọc"
                outlined
                @click="clearFilter()"
              />
              <span class="relative flex w-full">
                <i
                  class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400"
                />
                <InputText
                  class="!w-[400px] !pl-8 !pr-3"
                  v-model="filters['global'].value"
                  placeholder="Tìm theo tên hoặc tài khoản"
                />
              </span>
            </div>
          </div>
        </template>
        <Column field="fullname" header="Họ và tên" sortable></Column>
        <Column field="username" header="Tài khoản" sortable></Column>
        <Column field="phoneNumber" header="Số điện thoại" sortable></Column>
        <Column field="permission" header="Quyền hạn" sortable></Column>

        <Column field="civilGroupName" header="Tổ" sortable></Column>
        <Column header="Hành động">
          <template #body="slotProps">
            <Button
              type="button"
              label="Chỉnh sửa"
              icon="pi pi-pencil"
              @click="getUserById(slotProps.data.id)"
            >
            </Button>
          </template>
        </Column>
      </DataTable>
    </div>
    <div class="flex min-w-0 flex-col md:col-span-12">
      <Dialog
        v-model:visible="updateReg"
        :breakpoints="{ '1500px': '80vw', '1150px': '90vw' }"
        :modal="true"
        :closable="true"
        header="Cập nhật tài khoản"
      >
        <div class="space-y-4">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div class="flex min-w-0 flex-col">
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Họ và tên</label
              >
              <InputText
                id="fullname"
                type="text"
                v-model="userUpdate.fullname"
                placeholder="Nhập họ và tên"
                class="w-full"
              />
            </div>
            <div class="flex min-w-0 flex-col">
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Tên đăng nhập</label
              >
              <InputText
                id="username"
                type="text"
                v-model="userUpdate.username"
                placeholder="Nhập tên đăng nhập"
                class="w-full"
                disabled
              />
            </div>
            <div class="flex min-w-0 flex-col">
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Số điện thoại</label
              >
              <InputText
                id="phoneNumber"
                type="text"
                v-model="userUpdate.phoneNumber"
                placeholder="Nhập số điện thoại"
                class="w-full"
              />
            </div>
            <div class="flex min-w-0 flex-col">
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Mật khẩu (tối thiểu 6 ký tự)</label
              >
              <Password
                id="password"
                v-model="password"
                toggleMask
                :feedback="false"
                placeholder="Để trống nếu không đổi"
                class="w-full"
              />
            </div>
            <div class="flex min-w-0 flex-col">
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Chọn quyền hạn</label
              >
              <Dropdown
                id="permission"
                v-model="userUpdate.permission"
                :options="userPermission"
                optionLabel="label"
                optionValue="value"
                placeholder="Vui lòng chọn quyền hạn..."
                @change="selectPermission"
                class="w-full"
              />
            </div>

            <div
              class="flex min-w-0 flex-col"
              v-if="userUpdate.permission == 'civilGroup'"
            >
              <label class="mb-2 text-sm font-medium text-slate-700"
                >Chọn tổ</label
              >
              <Dropdown
                id="civilGroup"
                v-model="userUpdate.idCivilGroup"
                :options="listCivilGroup"
                optionLabel="civilGroupName"
                optionValue="id"
                placeholder="Vui lòng chọn tổ..."
                :filter="true"
                class="w-full"
              />
            </div>
          </div>

          <div class="flex justify-end gap-3 pt-4">
            <Button
              label="Xoá"
              severity="danger"
              icon="pi pi-trash"
              iconPos="left"
              @click="del($event)"
              :loading="deletingUser"
              class="px-4 py-2"
            />
            <Button
              label="Cập nhật"
              icon="pi pi-check"
              iconPos="left"
              @click="doUpdate()"
              :loading="updatingUser"
              :disabled="!valid"
              class="px-4 py-2"
            />
          </div>
        </div>
      </Dialog>
    </div>

    <!-- Confirm Delete Modal -->
    <ConfirmDeleteModal
      v-model="showConfirmModal"
      :title="confirmTitle"
      :message="confirmMessage"
      :is-loading="isConfirming"
      @confirm="confirmDelete.confirm"
      @cancel="confirmDelete.cancel"
    />
  </Panel>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useToast } from "@/ui/services/toast";
import AuthRepository from "@/services/AuthRepository";
import { useStore } from "vuex";
import router from "@/router";
import { FilterMatchMode } from "@/ui/services/api";
import { Team } from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import moment from "moment";
import authRepository from "@/services/AuthRepository";
import { UserDetail } from "@/models/userDetail";
import { UserUpdate } from "@/models/userUpdate";
import Ward from "@/models/Ward.models";
import CivilGroup from "@/models/CivilGroup.models";
import zaloRepository from "@/services/ZaloRepository";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";

export default {
  components: {
    ConfirmDeleteModal,
  },
  setup() {
    const toast = useToast();
    const isLoading = ref(false);
    const updateReg = ref(false);
    const list = ref([] as UserDetail[]);
    const store = useStore();
    const userUpdate = ref({} as UserUpdate);
    const password = ref("");
    const updatingUser = ref(false);
    const deletingUser = ref(false);
    const userPermission = ref([
      { label: "Tài khoản cấp tổ", value: "civilGroup" },
      // { label: 'Tài khoản cấp phường', value: 'ward' },
      // { label: 'Tài khoản cấp quận', value: 'district' },
      { label: "Quản lý", value: "admin" },
    ]);
    const ward = ref({} as Ward);
    const civilGroup = ref({} as CivilGroup);
    const listWard = ref([] as Ward[]);
    const listCivilGroup = ref([] as CivilGroup[]);

    // Use confirm delete composable
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;

    if (!(store.state.permission == "admin")) {
      router.push({
        name: "home",
      });
    }

    const getListUser = () => {
      authRepository
        .getListUser()
        .then((response) => {
          isLoading.value = true;
          list.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
          isLoading.value = false;
        })
        .finally(() => {
          isLoading.value = false;
        });
    };
    getListUser();

    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };
    const formatDateTime = (date) => {
      return moment(String(date)).format("DD/MM/YYYY");
    };
    const permissionName = (st) => {
      if (st == "master") return "Quản lý tòa nhà";
      else return "Nhân viên công ty";
    };

    const valid = computed(() => {
      console.log(
        "$$$$$$$############### debug permission: " +
          userUpdate.value.permission,
      );
      if (userUpdate.value.permission == "civilGroup") {
        return (
          userUpdate.value.fullname &&
          userUpdate.value.username &&
          userUpdate.value.phoneNumber
        );
      } else if (userUpdate.value.permission == "ward") {
        return userUpdate.value.fullname && userUpdate.value.username;
      } else if (
        userUpdate.value.permission == "district" ||
        userUpdate.value.permission == "admin"
      ) {
        return userUpdate.value.fullname && userUpdate.value.username;
      }
    });

    zaloRepository
      .getListWard()
      .then((response) => {
        listWard.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: err.response.data,
          life: 2000,
        });
      });

    const doUpdate = () => {
      if (
        password.value.trim().length < 6 &&
        password.value.trim().length > 0
      ) {
        toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu",
          life: 2000,
        });
      } else {
        // const temp = ref({} as UserUpdate);
        // userUpdate.value.password = "";
        // userUpdate.value.idWard = temp.value.idWard;
        // userUpdate.value.idCivilGroup = temp.value.idCivilGroup;

        console.log(
          "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 civilGroup: " +
            JSON.stringify(civilGroup.value),
        );
        console.log(
          "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 ward: " +
            JSON.stringify(ward.value),
        );

        if (password.value.trim().length == 0) {
          userUpdate.value.password = "";
        } else {
          var md5 = require("md5");
          userUpdate.value.password = password.value.trim();
        }
        if (ward.value != null) {
          userUpdate.value.idWard = ward.value.id;
        }
        // if(civilGroup.value != null)
        // {
        //   userUpdate.value.idWard = ward.value.id;
        //   // userUpdate.value.idCivilGroup = civilGroup.value.id;
        // }
        updatingUser.value = true;
        AuthRepository.updateUser(userUpdate.value)
          .then((response) => {
            console.log(
              "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222: " +
                JSON.stringify(userUpdate.value),
            );
            toast.add({
              severity: "success",
              summary: "Cập nhật",
              detail: "Cập nhật thông tin tài khoản thành công",
              life: 2000,
            });
            getListUser();
            updateReg.value = false;
            // router.push({
            //   name: 'home'
            // });
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          })
          .finally(() => {
            updatingUser.value = false;
          });
      }
    };

    const del = () => {
      confirmDelete.open({
        title: "Xác nhận xoá",
        message: "Bạn có chắc chắn muốn xoá tài khoản này?",
        onConfirm: async () => {
          deletingUser.value = true;
          try {
            await AuthRepository.deleteUser(userUpdate.value.id);
            toast.add({
              severity: "success",
              summary: "Thành công",
              detail: "Tài khoản đã được xoá thành công",
              life: 3000,
            });
            updateReg.value = false;
            getListUser();
          } catch (err: any) {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response?.data || "Xoá tài khoản không thành công",
              life: 3000,
            });
          } finally {
            deletingUser.value = false;
          }
        },
      });
    };

    const selectPermission = () => {
      listWard.value = [];
      //listCivilGroup.value = [];
      const wardtemp = ref({} as Ward);
      const civilGrouptemp = ref({} as CivilGroup);
      ward.value = wardtemp.value;
      civilGroup.value = civilGrouptemp.value;
      if (
        userUpdate.value.permission == "civilGroup" ||
        userUpdate.value.permission == "ward"
      ) {
        zaloRepository
          .getListWard()
          .then((response) => {
            listWard.value = response.data;
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };
    const selectWard = () => {
      listCivilGroup.value = [];
      // if((userUpdate.value.permission == "civilGroup"))
      {
        zaloRepository
          .getListCivilGroup()
          .then((response) => {
            listCivilGroup.value = response.data;
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };

    const getUserById = (id) => {
      updateReg.value = true;
      AuthRepository.getUserById(id)
        .then((response) => {
          console.log("########$$$$$$$$$$$$$$$$$$$$ userUpdate: ");
          userUpdate.value = response.data;
          userUpdate.value.password = "";
          console.log(
            "########$$$$$$$$$$$$$$$$$$$$ userUpdate: " +
              JSON.stringify(userUpdate.value),
          );
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        });
    };

    selectWard();

    return {
      list,
      filters,
      clearFilter,
      initFilters,
      formatDateTime,
      permissionName,
      userUpdate,
      doUpdate,
      del,
      userPermission,
      password,
      listWard,
      listCivilGroup,
      ward,
      civilGroup,
      selectPermission,
      selectWard,
      valid,
      updateReg,
      getUserById,
      updatingUser,
      deletingUser,
      // Confirm delete modal
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      isLoading,
      isConfirming,
      confirmDelete,
    };
  },
};
</script>
